export default {
    validateEmail: (val) => {

        // return /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
        //     val,
        // )
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            val
        );
    },
    validateMultipleEmail: (val) => {
        return /^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([;,.](([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/.test(
            val,
        )
    },
    validateMobile: (val) => {
        return /^\+?\d{9,12}$/.test(val)
    },

    validateFreeSpace: (val) => {
        return /^$|^[^\s]+(\s+[^\s]+)*$/.test(val)
    },
    validateMobileWithoutCC: (val) => {
        return /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(val)
    },
    validateString: (val) => {
        return /^\S[a-zA-Z\x20]{0,25}$/.test(val)
    },
    validatePassword: (val) => {
        // return /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[@#$%^&*!()]).{8,20}$/.test(val);
        return /^(?=[^0-9])(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[^A-Za-z0-9\s]).{8,20}$/.test(val)

        // return /^(?=.*[A-Za-z])(?=.*[0-9!@#$%^&*_])[A-Za-z0-9!@#$%^&*_]{8,50}$/.test(val);
    },

    validateNumbers: (val) => {
        return /^[0-9]{0,}$/.test(val)
    },

    validateFloat: (val) => {
        return /^[-+]?[0-9]*\.?[0-9]*$/.test(val)
    },

    validateInteger: (val) => {
        return /^\d*[1-9]\d*$/.test(val)
    },
    validateURL: (url) => {
        return /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/.test(
            url,
        )
    },
    validatePrice: (val) => {
        return /^(\d*([.,](?=\d{1}))?\d+)?$/.test(val)
    },
    validateAlphaNumberic: (val) => {
        return /^[a-zA-Z0-9]{0,20}$/.test(val)
    },
    getNumbericValuesFromString: (val) => {
        return val.match(/^\d+|\d+\b|\d+(?=\w)/g)
    },

    isValidAlphabate: (val) => {
        return /^[a-zA-z\s]+$/.test(val)
    },

    isValidAlphaNumeric: (val) => {
        return /^(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/? ]*$/.test(val)
    },

    validateStartDate: (val) => /^\d{4}-\d{2}-\d{2}$/.test(val) && new Date(val) >= new Date(new Date().toISOString().split('T')[0]),

    validateEditorContent: (val) => {
        const textContent = val.replace(/<\/?[^>]+(>|$)/g, "").trim();
        return textContent !== "";
    }
}
